import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { AccessControlProvider } from "@genie-ui/react";
import { Header } from "@components/templates";
import { AppLoading } from "@components/atom";
import { Constants } from "@constants/Constants";
import { ActisReportingConstants } from "@constants/ActisReportingConstants";
/* eslint-disable import/no-unresolved */
import {
  createStateSubscription,
  destroyStateSubscription,
} from "@gartner/genie-messenger-util";
import { ActisReporting, ACTIS_REPORTING } from "@utils/actisReporting";
import "./app.scss";

const App = (props) => {
  const [currentUser, setCurrentUser] = useState();
  const [searchData, setSearchData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [showLoader, setShowLoader] = useState(true);
  const loginRedirectParam = searchParams.get("login");
  ActisReporting.prototype.binder = { ...currentUser };

  useEffect(() => {
    if (currentUser?.userId) {
      ACTIS_REPORTING.APP_LOAD.push({
        label: `${currentUser?.userId}|${currentUser?.orgId}|${currentUser?.companyName}`,
        action: ActisReportingConstants.PAGE_LOAD,
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (loginRedirectParam) {
      setShowLoader(false);
    }
  }, [loginRedirectParam]);

  useEffect(() => {
    const subscriptionLoginDetails = createStateSubscription(
      "login",
      (data) => {
        setCurrentUser(data);
      }
    );

    const subscriptionSearchDetails = createStateSubscription(
      "search",
      (data) => {
        setSearchData(data);
      }
    );

    return () => {
      destroyStateSubscription(subscriptionLoginDetails);
      destroyStateSubscription(subscriptionSearchDetails);
    };
  }, []);
  if (!currentUser?.statusCode || (currentUser?.statusCode === 401 && showLoader)) {
    return <AppLoading />;
  }

  return (
    <AccessControlProvider permissions={currentUser?.roles}>
      <div>
        <Header currentUser={currentUser} searchData={searchData} />
      </div>
    </AccessControlProvider>
  );
};

export default App;
